module.exports = "/_next/static/images/carlos-30b7843c0efd0079935233b9b31a9685.png";